import React from 'react'
import { Link, Route, Routes } from 'react-router-dom'

import { nestedRoutePath, routes } from '../../../constants/routes'

import ReceiptsIndex from './receipts/index'
import PayoutsIndex from './payouts/index'
import FinanceDashboard from './dashboard'


const AdminFinanceIndex = () => {
    return (
        <div className="side-nav-layout">
            <div className="side-nav">
                <ul className="nav-links">
                    <li>
                        <Link to={routes.adminFinanceIndex}>
                            Dashboard
                        </Link>
                    </li>
                    <li>
                        <Link to={routes.adminFinanceReceiptsIndex}>
                            Received Commissions
                        </Link>
                    </li>
                    <li>
                        <Link to={routes.adminFinancePayoutsIndex}>
                            Payouts
                        </Link>
                    </li>
                </ul>
            </div>
            <div className="content">
                <Routes>
                    <Route path={nestedRoutePath(routes.adminFinanceIndex, routes.adminFinanceReceiptsIndex, true)} element={<ReceiptsIndex />} />
                    <Route path={nestedRoutePath(routes.adminFinanceIndex, routes.adminFinancePayoutsIndex, true)} element={<PayoutsIndex />} />
                    <Route index element={<FinanceDashboard />} />
                </Routes>
            </div>
        </div>
    )
}

export default AdminFinanceIndex
